import React, { ReactElement, useState } from 'react'
import { Button, Typography, Grid } from '@material-ui/core'
import { useFormik } from 'formik'
import DecimalTextField from 'UI/TextField/DecimalTextField'
import { DECIMAL_PLACES } from 'constants/calcConstants'

interface Props {
  initialValues: any
  name: string
  selectedReps: any[]
  propsFormValues: any
  disabled: boolean | undefined
  totalFeeAmount: number
  propsSetFieldValue: (name: string, data: any[]) => void
  handleClosePopover: () => void
  classes: any
}

export default function SplitCommissionForm({
  initialValues,
  selectedReps,
  propsFormValues,
  propsSetFieldValue,
  handleClosePopover,
  name,
  disabled,
  totalFeeAmount,
  ...props
}: Props): ReactElement {
  const [error, setError] = useState<string | null>(null)

  const { values, handleSubmit, handleChange } = useFormik({
    initialValues,
    enableReinitialize: true,
    onSubmit: formValues => {
      const data = []
      let sum = 0
      let haveNegativeNumber = false

      for (const [key, value] of Object.entries(formValues)) {
        const numberKey = Number(key)
        const numberValue = Number(value)

        data.push({ id: numberKey, value: numberValue })
      }

      sum = data.reduce((acc, el) => {
        if (el.value < 0) {
          haveNegativeNumber = true
        }

        return acc + el.value
      }, 0)

      const roundedSum = Number(sum.toFixed(DECIMAL_PLACES))
      const roundedTotal = Number(totalFeeAmount.toFixed(DECIMAL_PLACES))

      if (roundedSum > roundedTotal) {
        return setError('Total split amount must equal the fee amount')
      }

      if (roundedSum < roundedTotal) {
        return setError('Total split amount must equal the fee amount')
      }

      if (roundedSum === roundedTotal && !haveNegativeNumber) {
        propsSetFieldValue(name, data)
        handleClosePopover()
      }
    },
  })

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        {selectedReps.map(({ id, name: repName }) => (
          <Grid item xs={12} key={`commission-amount-${id}`}>
            <DecimalTextField
              decimalScale={DECIMAL_PLACES}
              {...props}
              disabled={disabled}
              variant="outlined"
              placeholder="Amount"
              autoComplete={undefined}
              fullWidth
              InputLabelProps={{ shrink: true }}
              error={
                (!Number.isFinite(parseFloat(values[id])) &&
                  values[id] !== '' &&
                  values[id] !== undefined) ||
                parseFloat(values[id]) < 0
              }
              helperText={
                (!Number.isFinite(parseFloat(values[id])) &&
                  values[id] !== '' &&
                  values[id] !== undefined &&
                  'Numbers only') ||
                (parseFloat(values[id]) < 0 && 'Number should be positive') ||
                (totalFeeAmount > 0 &&
                  Number.isFinite(parseFloat(values[id])) &&
                  `Equivalent: ${(((parseFloat(values[id]) || 0) / totalFeeAmount) * 100).toFixed(4)}%`)
              }
              name={`${id}`}
              value={values[id]}
              onChange={handleChange}
              label={repName?.trim()}
            />
          </Grid>
        ))}
      </Grid>

      {error && (
        <Typography gutterBottom color="error">
          {error}
        </Typography>
      )}
      <Button type="submit" color="primary" variant="contained" fullWidth>
        Split
      </Button>
    </form>
  )
}
